<p-dialog
  [(visible)]="isDisplayingDialog"
  [draggable]="false"
  [modal]="true"
  [dismissableMask]="true"
  [showHeader]="false"
  [focusTrap]="false"
  (onHide)="closeModel()"
  position="top"
  maskStyleClass="detail-dialog"
  id="p-dialog_1ca03474"
>
  <ng-container
    *ngIf="isDisplayingDialog && !!detailViewObj"
    id="ng-container_179fbb42"
  >
    <app-detail-view-card
      [carDetails]="detailViewObj"
      [displayedAttr]="detailAttrList"
      [displayComplianceDue]="CarType.obj.field !== 'covered-hopper'"
      (closeModelFn)="closeModel()"
    >
    </app-detail-view-card>
  </ng-container>
</p-dialog>
<div class="content-container" id="div_content-container_4f00815d">
  <div
    class="banner"
    *ngIf="banner.enabled"
    [ngClass]="banner.color"
    id="div_banner_ab282f67"
  >
    <span
      *ngIf="!!banner.header"
      class="banner-title"
      id="span_banner-title_f4f7a814"
      >{{ banner.header }}</span
    >
    <span class="banner-body" id="span_banner-body_fb35e825">{{
      banner.message
    }}</span>

    <i class="pi pi-times" (click)="disableBannerFn()" id="i_pi_aa2d5aa9"></i>
  </div>

  <div class="header-container" id="div_header-container_b5b7f062">
    <div class="header-text" id="div_header-text_8bec456c">
      <span class="title" id="span_title_c352cd3b">{{
        displayedCars.length === 0 ? 'Search Results' : CarType.obj.title
      }}</span
      ><br />
      <span class="subtitle" id="span_subtitle_83156336"
        >To begin a quote, select the product and railcar type to the left. You
        will have an opportunity to provide mechanical options and leasing
        criteria on the following pages.</span
      >
    </div>
    <button
      class="header-selection-btn"
      (click)="beginQuoteRequest()"
      [ngClass]="beginQuoteReqEnabled() ? 'btn-active' : 'btn-inactive'"
      pButton=""
      type="button"
      id="button_header-selection-btn_83bce9b7"
    >
      BEGIN QUOTE REQUEST
    </button>
  </div>
  <div class="card-container" id="div_card-container_b33b78f0">
    <div class="card-container-header" id="div_card-container-header_367bc63a">
      <div
        class="card-container-header-left"
        [ngClass]="displayedCars.length > 0 ? 'enabled-text' : 'disabled-text'"
        id="div_card-container-header-left_30743228"
      >
        <div
          class="d-flex align-items-center width-mob"
          id="div_d-flex_53aae9b3"
        >
          <div
            class="select-all-btn"
            (click)="selectAll()"
            [ngClass]="
              displayedCars.length > 0 && stccValid()
                ? 'select-enabled'
                : 'select-disabled'
            "
            id="div_select-all-btn_255595b1"
          >
            Select All
            <i class="pi pi-check mobile-icon" id="i_pi_e5ab37b6"></i>
          </div>

          <span
            class="railcar-count"
            *ngIf="!quoteRequestService.gettingCarList()"
            id="span_railcar-count_dc1d7951"
            >{{ matchCt }} Match<ng-container
              *ngIf="matchCt !== 1"
              id="ng-container_6e0ac163"
              >es</ng-container
            ></span
          >
        </div>
        <div
          (click)="openFilterbox()"
          class="filter-button"
          id="div_filter-button_76e192c4"
        >
          Filter
          <img
            aria-label="filter list"
            title="filter list"
            src="/assets/icons/filter-list.svg"
            alt="filter list"
            id="img_6bf08434"
          />
        </div>
      </div>
      <div
        class="card-container-header-right"
        [ngClass]="selectedNum === 0 ? 'inactive' : 'active'"
        id="div_card-container-header-right_fb62e4c3"
      >
        <div id="div_52faa95e">
          <span class="selected-num" id="span_selected-num_3f7a2c1f"
            >{{ selectedNum }}&nbsp;</span
          >
          <span class="selections" id="span_selections_5e650f1a"
            >Selections</span
          >
        </div>
        <div id="div_baae5288">
          <span
            class="count"
            [ngClass]="
              displayedCars.length > 0 ? 'enabled-text' : 'disabled-text'
            "
            *ngIf="!quoteRequestService.gettingCarList()"
            id="span_count_c06d0811"
            >{{ matchCt }} Match<ng-container
              *ngIf="matchCt !== 1"
              id="ng-container_b023d95f"
              >es</ng-container
            ></span
          >
        </div>
      </div>
    </div>
    <span
      *ngIf="ValidationFilterMobile && !stccValid()"
      class="validation-mobile"
      id="span_validation-mobile_d1e14f57"
    >
      <small id="small_85a0d112"
        >Please select a product STCC# using the filter section
      </small>
    </span>
    <div
      class="card-container-body"
      *ngIf="displayedCars.length !== 0; else blank"
      id="div_card-container-body_496ecf88"
    >
      <ng-container
        *ngFor="let car of displayedCars"
        id="ng-container_6518fc68"
      >
        <app-quick-view-card
          [carDetails]="car"
          [displayedAttr]="cardAttrList"
          (cardToggled)="cardToggled($event)"
          (openModelFn)="openModel($event)"
          (ValidationFilter)="showValidation($event)"
          [selectEnabled]="stccValid()"
          [selected]="
            this.selectedCars[car.model_id + '_' + car.status] !== undefined
          "
        ></app-quick-view-card>
      </ng-container>
    </div>
    <ng-template #blank="" id="ng-template_2f8234bf">
      <div class="card-container-body" id="div_card-container-body_9b7ac40b">
        <ng-container
          *ngFor="let blank of ['', '', '']"
          id="ng-container_1b33668e"
        >
          <app-quick-view-card [blank]="true"></app-quick-view-card>
        </ng-container>
      </div>
    </ng-template>
  </div>
  <div
    class="footer-container"
    *ngIf="displayedCars.length > 0"
    id="div_footer-container_c7583dbe"
  >
    <p
      aria-label="Pricing & Availability"
      title="Pricing & Availability"
      class="footer-title"
      id="p_footer-title_0f2f9c54"
    >
      Pricing & Availability
    </p>
    <p class="footer-body" id="p_footer-body_6c545455">
      Prices shown are base railcar estimates, are not guaranteed, and are
      subject to change based on specific customer requirements including, but
      not limited to, intended commodity usage, railcar modifications and
      freight or other costs. Railcars displayed in search results are based on
      <i id="i_e004fbb7">TrinityRail</i>® available inventory at time of search
      and subject to change. Total or partial railcar groupings are not
      guaranteed. Specific pricing and railcar details will be provided during
      the quoting process. All prices shown are in USD.
    </p>

    <p
      title="selected railcars"
      class="footer-title"
      id="p_footer-title_98a2f829"
    >
      What does “selected railcars” mean?
    </p>
    <p class="footer-body" id="p_footer-body_7dab17a1">
      Product matching to eligible car types is not guaranteed and is subject to
      review during quoting process. If your product is not listed, please
      select “Other” in the product field and enter the product name to make car
      selections and continue to request a quote.
    </p>

    <p
      aria-label="TRM footer"
      title="TRM footer"
      class="footer-body"
      id="p_footer-body_bca6f7a4"
    >
      Images and railcar details displayed are for illustration purposes only
      and may not be an exact representation of each railcar. Specific product
      attributes are nominal values and subject to variation when compared to
      mechanical spec. <i id="i_6338524d">TrinityRail</i>® reserves the right
      to change product images at any time without notice.
    </p>
  </div>
</div>
